// Helpers for parsing Game Coordinator (GC) recorded events.
//
// Edge stores events as: { payload: <requestBody> }
// Collector often POSTs: { payload: { method, path, body, timestamp } }
// So the effective event payload is usually in `event.payload.payload`.

export function unwrapGcEventPayload(event) {
  return event?.payload?.payload || event?.payload || null;
}

export function getGcEventType(event) {
  const payload = unwrapGcEventPayload(event);
  return payload?.body?.event || null;
}

export function getGcEventTimestampUnix(event) {
  const payload = unwrapGcEventPayload(event);
  const ts = payload?.timestamp || null;
  if (!ts) return null;
  const ms = Date.parse(ts);
  if (!Number.isFinite(ms)) return null;
  return Math.floor(ms / 1000);
}

export function normalizeUnixSeconds(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;

  // seconds ~ 1.7e9, ms ~ 1.7e12
  if (n >= 1_000_000_000_000) return Math.floor(n / 1000); // ms -> sec
  return Math.floor(n); // already seconds
}

